import { apiEndpoints } from "../../constants";
import { BaseService } from "./baseService";

class NewsServices extends BaseService {
  async getNews(page: number) {
    return await this.get(`${apiEndpoints.NEWS.GET_NEWS}?page=${page}`);
  }

  async getNewsById(id: number) {
    return await this.get(`${apiEndpoints.NEWS.GET_NEWS}/${id.toString()}`);
  }
}

const newsServices = new NewsServices();
export default newsServices;
